export const isValidMessage = (message: string, patterns: string[]): boolean => {
    return !patterns.some((pattern) => {
        const regExp = new RegExp(pattern);

        return regExp.test(message);
    });
};
